import React, { useCallback, useState } from 'react';
import { Button } from '@umu/umu-design';
import { INodeEditorProps } from '../interface/svgEditor';
import NodeItem from './NodeItem';
import { IPackageDownloadResult } from '../interface/download';

const NodeEditor: React.FC<INodeEditorProps> = ({
    nodeConfigs,
    nodeValuesRef,
    onInputChange,
    onButtonClick,
    onReset,
    onDownload,
    className = '',
}) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadResult, setDownloadResult] = useState<IPackageDownloadResult | null>(null);
    const handleDownload = useCallback(async () => {
        if (isDownloading) {
            return;
        }
        setIsDownloading(true);
        const result = await onDownload();
        setDownloadResult(result);
        setIsDownloading(false);
    }, [onDownload]);

    return (
        <div className={`svg-editor-bottom-panel ${className}`}>
            <div className="svg-editor-node-editor">
                {nodeConfigs.map((config) => (
                    <NodeItem
                        key={config.key}
                        config={config}
                        value={nodeValuesRef.current?.[config.key] || config.defaultValue}
                        onInputChange={(value) => onInputChange(config.key, value)}
                        onButtonClick={() => onButtonClick(config.key)}
                    />
                ))}
                <div className="svg-editor-node-group">
                    <label className="svg-editor-node-label">操作</label>
                    <Button type="ghost" onClick={onReset}>
                        重置
                    </Button>
                    <Button type="primary" disabled={isDownloading} onClick={handleDownload}>
                        下载
                    </Button>
                </div>
            </div>
            {downloadResult && (
                <pre className="svg-editor-download-result">{JSON.stringify(downloadResult || {}, null, 2)}</pre>
            )}
        </div>
    );
};

export default NodeEditor;
